import { detectCopyableParseFailure } from '@littlebird/markdown-utils';

export function buildCopyableParseFailurePayload({
  threadId,
  messageId,
  smoothdownId,
  rawContent,
  smoothedContent,
  balancedContent,
}: {
  threadId: string;
  messageId: string;
  smoothdownId: string;
  rawContent: string;
  smoothedContent: string;
  balancedContent: string;
}) {
  const diagnostics = detectCopyableParseFailure({
    rawContent,
    smoothedContent,
    balancedContent,
  });
  if (!diagnostics) return null;

  return {
    surface: 'assistant_chat' as const,
    threadId,
    messageId,
    smoothdownId,
    ...diagnostics,
  };
}
